// components/PaymentDetailsCard.js
import React from 'react';
import { Card, CardBody, CardHeader, Button } from 'reactstrap';

export default function PaymentDetailsCard({ card, onReplaceCard }) {
  if (!card) return null;

  // Determine card initials for icon box (first 2 letters of brand)
  const cardInitials = card.brand?.slice(0, 2).toUpperCase() || 'CC';
  const exp = `${card.expMonth.toString().padStart(2, '0')}/${card.expYear}`;

  return (
    <Card className="shadow-sm">
      <CardHeader className="d-flex justify-content-between align-items-center">
        <h5 className="mb-0">Payment details</h5>
        <Button
          color="link"
          className="p-0 text-decoration-underline text-dark"
          onClick={onReplaceCard}
        >
          <i className="fas fa-pen me-1"></i>Edit
        </Button>
      </CardHeader>
      <CardBody>
        <div className="d-flex align-items-center mb-3">
          <div
            className="bg-primary text-white rounded fw-bold text-center"
            style={{ width: '2rem', height: '1.25rem', lineHeight: '1.25rem' }}
          >
            {cardInitials}
          </div>
          <div className="ms-3">
            <div className="fw-medium">•••• •••• •••• {card.last4}</div>
            <div className="text-muted small">
              {card.brand} • Expires {exp}
            </div>
          </div>
        </div>
        <div className="bg-light p-2 rounded text-muted small">
          Billed on 1st of every {card.interval || 'month'}.
          {card.nextBillingDate &&
            ` Next billing on ${new Date(card.nextBillingDate).toLocaleDateString()}.`}
        </div>
      </CardBody>
    </Card>
  );
}
